import React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";

import DeleteReturnEventsModalContent from "./DeleteReturnEventsModalContent";

import { toggleDeleteReturnEventModal } from "../../../../store/common/modal/action";

export default function ReturnEventsModal() {
  const dispatch = useDispatch();
  return (
    <>
      <DeleteReturnEventsModalBg
        onClick={() => dispatch(toggleDeleteReturnEventModal(false))}
      ></DeleteReturnEventsModalBg>
      <DeleteReturnEventsModalContent />
    </>
  );
}

// ===================================================================================
// スタイル
// ===================================================================================
const DeleteReturnEventsModalBg = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 110;
`;
